const RELIGION_STANDARDS = {
  "Religion": {
    // Domains only, no standards yet
    "K-2": {
      "Sacred Texts & Teachings": [],
      "Beliefs & Practices": [],
      "Faith & Community": []
    },
    "3-5": {
      "Sacred Texts & Teachings": [],
      "Beliefs & Practices": [],
      "Religious History & Culture": [],
      "Faith & Community": []
    },
    "6-8": {
      "Sacred Texts & Teachings": [],
      "Ethics & Morality": [],
      "Comparative Religion": [],
      "Religious History & Culture": []
    },
    "High School": {
      "Sacred Texts & Teachings": [],
      "Beliefs & Practices": [],
      "Ethics & Morality": [],
      "Comparative Religion": [],
      "Religious History & Culture": [],
      "Faith & Community": []
    }
  }
};

export default RELIGION_STANDARDS;
